import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const productReviewImporterSelectors = importerSelectors(
  'productReview.importer',
)

export default productReviewImporterSelectors
